import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'

export const Card = styled(Box)`
    width: 300px;
    height: 380px;
    margin-bottom: 20px;
    background: ${({ theme }) => theme.colors.white};
    border-radius: 30px;
    display: block;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 410px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 300px;
        height: 410px;
        margin-bottom: 20px;
        background: ${({ theme }) => theme.colors.white};
    }
`
export const SectionCard = styled(motion(Box))`
    margin: 30px;
    display: none;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: flex;
        flex-direction: column;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SectionCardMobile = styled(motion(Box))`
    margin: 30px;
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const FontImage = styled(Box)`
    width: 100%;
    height: 170px;
    background: #c9c9c9;
    border-radius: 15px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ImageSection = styled.img`
    width: 100%;
    object-fit: contain;
    height: 100%;
    border-radius: 15px;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const TypographySection = styled(Box)`
    height: 70%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Name = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    color: ${({ theme }) => theme.colors.primary};
    line-height: 24px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 24px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 24px;
    }
`
